<template>
    <div id='formbackground' v-if='display' >
        <div id='formPL' @keyup.enter="clickBtnForm()">
            <button v-if="showCloseBtn()"  @click="closeForm()" id='closeFormBtn'>X</button>
            
            <h1 class="form_title">{{title_txt}}</h1>

            <!-- Champs principal, l'info la plus importante pour le form -->
            <div class="form_row" v-if="showPlaceholder">
                <input v-model="dataObj.name" class="form_input" type="text" :placeholder="main_placeholder"
                    :disabled="(mode=='login' && getStatus == 'loading') || (validation && mode!='forget_Mdp')" :name="main_placeholder"
                />
            </div>

            <!-- Affichage du prenom -->
            <div class="form_row" v-if="mode=='formUser_new' || mode=='formUser_edit' || mode=='formUser_remove'">
                <input v-model="dataObj.firstName" class="form_input"  :disabled="validation"
                    type="text" placeholder="Prénom"  name='prenom'  />
            </div>

            <!-- Affichage de l'adresse mail -->
            <div class="form_row" v-if="mode=='formUser_new' || mode=='formUser_edit' || mode=='formUser_remove'">
                <input v-model="dataObj.mail" class="form_input" :disabled="validation"
                type="text" placeholder="Adresse mail" name='mail' />
            </div>

            <!-- Affichage des notes -->
            <div class="form_row" v-if="mode=='formUser_new' || mode=='formUser_edit' || mode=='formIP_edit' || mode=='formIP_new' || mode=='formAPI_edit' || mode=='formAPI_new' ">
                <input v-model="dataObj.note" class="form_input" :disabled="validation"
                 type="text" placeholder="Notes" name='note' />
            </div>

            <!-- Liste des rôles -->
            <div class="form_row" v-if="(mode=='formUser_new' || mode=='formUser_edit') && isRoleAbove(dataObj.role)">
                <select v-model="dataObj.role" class="form_input" :disabled="validation">
                    <option value="" disabled>Rôle</option>
                    <option v-if="isRole(SUPERADMIN.value)" :value="SUPERADMIN.value">{{SUPERADMIN.string}}</option>
                    <option v-if="isRole(SUPERADMIN.value) || isRole(ADMIN.value)" :value="ADMIN.value">{{ADMIN.string}}</option>
                    <option :value="LINGUIST.value">{{LINGUIST.string}}</option>
                </select>
            </div>

            <!-- Liste des configuration -->
            <div class="form_row" v-if="showConfigFormLine()">
                <select v-model="dataObj.settingId" class="form_input" :disabled="validation">
                    <option v-for="(setting) in settingsForm" :key='setting.id' :value='setting.id' :selected="dataObj.settingId == setting.id">{{setting.name}}</option>
                </select>
            </div>

            <!-- Affichage du code client -->
            <div class="form_row" v-if="mode=='formClient_new' || mode=='formClient_edit' || mode=='formClient_remove'">
                <input v-model="dataObj.code" class="form_input" @input="filterInput" :disabled="validation" 
                    type="text" placeholder="12345-67"  name='code'  />
            </div>
            
            <!-- Activation de l'IP ou de la clé d'API -->
            <div class="form_row" v-if="showSwitchButton()">
                <label class="form_checkbox_txt green" v-if="dataObj.active">{{(mode=='formAPI_edit') ? "clé d'API" : "IP"}} active</label>
                <label class="form_checkbox_txt red" v-else>{{(mode=='formAPI_edit') ? "clé d'API" : "IP"}} inactive</label>
                <switch-button  :isEnabled="dataObj.active" :color="(dataObj.active) ? '#00aa00' : '#cc0b00'" @toggle="dataObj.active = !dataObj.active" :disabled="validation"></switch-button>
            </div>

            <!-- Champs pour mots de passe pour login ou forget_Mdp -->
            <div class="form_row" v-if="mode=='login'">
                <input v-model="pswd" class="form_input" type="password" placeholder="Mot de passe" 
                    :disabled="(mode=='login' && getStatus == 'loading') || validation"
                />
            </div>

            <!-- Oubli de mdp -->
            <div class="form_row" v-if="mode == 'login'">
                <a id="forget_mdp" @click="changeModeTo('forget_Mdp')">Mot de passe oublié ?</a>
            </div>

            <div class="form_row" v-if="mode == 'formPref_unavailable'">
                <p>Cette fonctionnalité est indisponible</p>
            </div>

            <!--  Ligne d'Erreur : TODO faire une fonction avec des parametres pour toutes les erreurs / plus evolutifs et discret -->
            <div class="form_row form_error" v-if="mode == 'formClient_new' && form_status == 'error_create'">
                Attention : Charactère interdit dans le nom du client
            </div>

            <div class="form_row form_error" v-if="(mode == 'formClient_new' || mode == 'formClient_edit') && form_status == 'error_code'">
                Attention : Le code client doit être de la forme "12345-67" ou "25294-002"
            </div>

            <div class="form_row form_error" v-if="mode == 'formUser_new' && form_status == 'error_mail'">
                Attention : Adresse email invalide
            </div>

            <div class="form_row form_error" v-if="mode == 'formIP_new' && form_status == 'error_ip'">
                Attention : Adresse IP invalide
            </div>

            <div class="form_row form_error" v-if="mode.indexOf('formDico_new') != -1 && form_status == 'error_mail'">
                Attention : Le nom du dictionnaire contient un caractére invalide
            </div>

            <div class="form_row form_error" v-if="getStatus == 'error_login'">
                Erreur dans les informations de login
            </div>

            <div class="form_row form_error" v-if="form_status == 'error_userforget'">
                Cette adresse e-mail n'est pas reconnue.
                <br/>
                Vérifiez que cette adresse correspond bien à celle enregistrée dans le portail ProLexis WebService ?
            </div>

            <div class="form_row green" v-if="form_status == 'valid_userforget'">
                L’e-mail de réinitialisation du mot de passe a été envoyé.
            </div>

            <!-- Bouton de validation : 1 bouton-->
            <button v-if="showOneBtnValidate()"  @click="showValidation()" class="form_button" :class="{'form_button_disabled' : (!validatedFields || validation)}" :disabled="!validatedFields || validation">
                <span >{{btn_txt}}</span>
            </button>
            <button v-else-if="mode.indexOf('remove') == -1 && mode!='forget_Mdp'" @click="clickBtnForm()" class="form_button" :class="{'form_button_disabled' : !validatedFields}">
                <span v-if="getStatus == 'loading'">Connexion en cours...</span>
                <span v-else>Connexion</span>
            </button>

            <!-- Bouton de validation de la validation : 2 boutons : valider / annuler -->
            <div  class="form_row validation " :class="{'showbtn' : validation}" >
                <button class="form_button half_btn"   @click="cancelValidation()" >
                    <span >Annuler</span>
                </button>     
                <button class="form_button half_btn" :class="{'form_button_disabled' : (!validatedFields)}" @click="clickBtnForm()">
                    <span >Confirmer</span>
                </button>     
            </div>

            <div class="form_row form_error" v-if="form_status == 'error_after' && errorTxt != ''">
                <b>{{errorTxt}}</b>
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { diagonalbackURL, defaultConfig, URLEncodedConfig } from "../constantes";
    import FctUtils from '@/components/FctUtils';
    import { RoleEnum } from '../classes/enums';
    import SwitchButton from "./SwitchButton";

    export default {
        name: "FormPl",
        mixins: [FctUtils],
        components: {
            'switch-button' : SwitchButton,
        }, 
        props:{
            id:'',
        },
        data: function () {
            return {
                display:false,
                form_status:'no_error',
                mode: 'login',
                pswd:'',
                validation:false, // demande la validation de l'action courante (surtout modif et suppression)

                dataObj:{
                    id:'',
                    name: '',
                    firstName: '',
                    mail: '',
                    note: '',
                    role: RoleEnum.LINGUIST.value,
                    active:false,
                    clientId:'',
                    settingId:'',
                    code:''
                },
                settingsForm:{},

                title_txt:'',
                main_placeholder:'',
                showPlaceholder: true, 
                btn_txt:'',
                errorTxt:"",
                // password: '',
            }
        },
        created() {
            this.SUPERADMIN = RoleEnum.SUPERADMIN;
            this.ADMIN      = RoleEnum.ADMIN;
            this.LINGUIST   = RoleEnum.LINGUIST;
        },
        mounted() {
            this.emitter.on('showPLForm', newformInfos => {
                this.showForm(newformInfos)
            });

            this.emitter.on('showPLFormError', newformInfos => {
                this.showFormError(newformInfos)
            });
        },
        computed:{
            getStatus:function() {
                return this.$store.getters.status;
            },
            validatedFields: function () {
                // Cette variable permet de disabled le bouton de creation/modification/suppression d'un objet
                // si tous les champs necessaire a l'objet remplisse les conditions qui leur sont demandé
                // ex : non vide, ou suis une reg exp (IP)
                //
                this.form_status = 'no_error'

                // Pour l'ajout ou la modification d'un client
                // 
                if (this.mode == 'formClient_new' || this.mode == 'formClient_edit') {
                    // Si nom du client non vide 
                    //
                    if (this.noEmpty(this.dataObj.name)) {
                        var aTabIllegallCharacter = ['/', '\\'];
                        var i = 0;
                        
                        for (i = 0; i < aTabIllegallCharacter.length; i++) {
                            if (this.dataObj.name.indexOf(aTabIllegallCharacter[i]) != -1) {
                                this.form_status = 'error_create'
                                //alert('Le caractère '+ aTabIllegallCharacter[i] +' est interdit dans un nom de dictionnaire');
                                return false;
                            }
                        }

                        // [BUG#8205] : Ajout du code client sur le formulaire d'ajout/modification d'un client 
                        // Il doit respecter le format suivant ou être vide
                        //
                        const regex = /^[0-9]{5}-[0-9]{2,3}$/;
                        if  (!(!this.dataObj.code || regex.test(this.dataObj.code))) {
                            this.form_status = 'error_code';
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                    return true;
                }
                // Pour l'ajout ou la modification d'un intervenant
                // 
                else if (this.mode == 'formUser_new' || this.mode == 'formUser_edit') {
                    if (this.noEmpty(this.dataObj.name) && this.noEmpty(this.dataObj.firstName) && this.noEmpty(this.dataObj.mail)) {
                        if (this.dataObj.mail.match(/^[a-zA-Z0-9_!#$%&'*+/=?`{|}~^.-]+@[a-zA-Z0-9.-]+$/) ) {
                            return true;
                        }
                        else {
                            this.form_status = 'error_mail'
                        }
                    }
                }
                // Pour l'ajout ou la modification d'un domaine
                // 
                else if (this.mode == 'formHost_new' || this.mode == 'formHost_edit') {
                    if (this.noEmpty(this.dataObj.name)) {
                        return true;
                    }
                }
                // Pour l'ajout ou la modification d'une configuration
                // 
                else if (this.mode == 'formSetting_new' || this.mode == 'formSetting_edit') {
                    if (this.noEmpty(this.dataObj.name)) {
                        return true;
                    }
                }
                // Pour l'ajout ou la modification d'une IP
                // 
                else if (this.mode == 'formIP_new' || this.mode == 'formIP_edit') {
                    if (this.noEmpty(this.dataObj.name) && this.noEmpty(this.dataObj.settingId)) {
                        if (this.dataObj.name.match(/^(\b25[0-5]|\b2[0-4][0-9]|\b[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}(\/([0-9]|[1-2][0-9]|3[0-2]))?$/)) {
                            return true;
                        }
                        else {
                            this.form_status = 'error_ip'
                        }
                    }
                }
                // Pour l'ajout ou la modification d'une clé d'API
                // 
                else if (this.mode == 'formAPI_new' || this.mode == 'formAPI_edit') {
                    if (this.noEmpty(this.dataObj.name) && this.noEmpty(this.dataObj.settingId)) {
                        return true;
                    }
                }
                // Pour l'ajout ou la modification d'une clé de script
                //
                else if (this.mode == 'formScript_new' || this.mode == 'formScript_edit') {
                    if (this.noEmpty(this.dataObj.name)) {
                        return true;
                    }
                }
                // Pour l'ajout ou la modification d'un dictionnaire
                //
                else if (this.mode == "formDico_new" || this.mode == "formDico_edit"
                      || this.mode == "formCharte_new" || this.mode == "formCharte_edit"
                      || this.mode == "formTypo_new" || this.mode == "formTypo_edit") {
                    
                    if (this.noEmpty(this.dataObj.name) ) {
                        var aTabIllegallCharacter = ['/', '\\'];
                        var i = 0;

                        for (i = 0; i < aTabIllegallCharacter.length; i++) {
                            if (this.dataObj.name.indexOf(aTabIllegallCharacter[i]) != -1) {
                                this.form_status = 'error_dico'
                                console.log('Le caractère '+ aTabIllegallCharacter[i] +' est interdit dans un nom de dictionnaire');
                                return false;
                            }
                        }
                        // Verification passé avec succes
                        return true
                    }
                    else {
                        return false
                    }
                }
                // Lors du login
                // 
                else if (this.mode == 'login') {
                    if (this.noEmpty(this.dataObj.name) && this.noEmpty(this.pswd)) {
                        return true;
                    }
                }
                // Lors de la demande d'envoi d'un lien pour la reinitialisation du mdp
                // 
                else if (this.mode == 'forget_Mdp') {
                    if (this.noEmpty(this.dataObj.name)) {
                        return true;
                    }
                }
                //
                // Tous les formXXX_remove fonctionne pareil, les champs sont deja tous rempli, 
                // Il n'y a besoin que de confirmer ou annuler 
                //
                else if ((this.mode.indexOf('remove') != -1) || (this.mode = 'formPref_unavailable')) {
                    return true;
                }
                
                // Si pas de mode ou mode non configurer, on ne peux pas valider
                return false
            },
        },
        methods:{
            isRole(roleTest) {
                return this.$store.state.currentUser.role == roleTest;
            },
            isRoleAbove(roleTest) {
                if (this.isRole(RoleEnum.SUPERADMIN.value)) {
                    return true;
                }
                else if (this.isRole(RoleEnum.ADMIN.value) && roleTest != RoleEnum.SUPERADMIN.value) {
                    return true;
                }

                return false;
            },
            changeModeTo(newMode) {
                var newformInfos = {};

                newformInfos.mode = newMode;
                switch(newMode) {
                    case 'forget_Mdp' : {
                        //this.newformInfos.mode =  
                    } break;
                    case 'login' : {
                        
                    } break;
                }

                this.showForm(newformInfos);
            },
            // Affiche le formulaire, met à jour les labels pour le mode choisis
            // permet de positionner les variables selon les besoins
            //
            showForm(newformInfos){
                if (this.id == 'login' && newformInfos.mode == 'login') {
                    this.display = true;    
                }
                else if (this.id != 'login' && newformInfos.mode != 'login') {
                    this.display = true;
                } 
                this.mode=newformInfos.mode;

                switch(this.mode) {
                    case 'login' : {
                        this.title_txt='Authentification';
                        //this.btn_txt='Connexion';
                        this.main_placeholder='Adresse mail';
                    } break;
                    case 'forget_Mdp' : {
                        this.validation = true;
                        this.title_txt='Mot de passe oublié ?';
                        this.btn_txt='OK';
                        this.main_placeholder='Adresse mail';
                    } break;
                    //
                    // Creation d'un nouvel Objet
                    //
                    case 'formClient_new' : {
                        this.title_txt='Nouveau client';
                        this.btn_txt='Créer le client';
                        this.main_placeholder='Nom';
                    } break;
                    case 'formUser_new' : {
                        this.title_txt='Nouvel intervenant';
                        this.btn_txt='Créer l\'intervenant';
                        this.main_placeholder='Nom';
                    } break;
                    case 'formHost_new' : {
                        this.title_txt='Nouveau domaine';
                        this.btn_txt='Créer le domaine';
                        this.main_placeholder='Domaine';
                    } break;
                    case 'formSetting_new' : {
                        this.title_txt='Nouvelle configuration';
                        this.btn_txt='Créer la configuration';
                        this.main_placeholder='Configuration';
                    } break;
                    case 'formIP_new' : {
                        this.title_txt='Nouvelle IP';
                        this.btn_txt='Ajouter l\'IP';
                        this.main_placeholder='IP';
                    } break;
                    case 'formAPI_new' : {
                        this.title_txt='Nouvelle clé d\'API';
                        this.btn_txt='Ajouter la clé d\'API';
                        this.main_placeholder='clé d\'API';
                    } break;
                    case 'formDico_new' : {
                        this.title_txt='Nouveau dictionnaire';
                        this.btn_txt='Créer le dictionnaire';
                        this.main_placeholder='Nom du dictionnaire';
                    } break;
                    case 'formCharte_new' : {
                        this.title_txt='Nouvelle charte';
                        this.btn_txt='Créer la charte';
                        this.main_placeholder='Nom de la charte';
                    } break;
                    case 'formTypo_new' : {
                        this.title_txt='Nouveau dictionnaire typographique';
                        this.btn_txt='Créer le dictionnaire typographique';
                        this.main_placeholder='Nom du dictionnaire typographique';
                    } break;
                    case 'formScript_new' : {
                        this.title_txt='Nouvelle clé de script';
                        this.btn_txt='Ajouter la clé de script';
                        this.main_placeholder='Note';
                    } break;
                    //
                    // Maj d'un objet
                    //
                    case 'formClient_edit' : {
                        this.title_txt='Modification d\'un client';
                        this.btn_txt='Modifier le client';
                        this.main_placeholder='Nom';
                    } break;
                    case 'formUser_edit' : {
                        this.title_txt='Modification d\'un intervenant';
                        this.btn_txt='Modifier l\'intervenant';
                        this.main_placeholder='Nom';
                    } break;
                    case 'formHost_edit' : {
                        this.title_txt='Modification d\'un domaine';
                        this.btn_txt='Modifier le domaine';
                        this.main_placeholder='Domaine';
                    } break;
                    case 'formSetting_edit' : {
                        this.title_txt='Modification d\'une configuration';
                        this.btn_txt='Modifier la configuration';
                        this.main_placeholder='Configuration';
                    } break;
                    case 'formIP_edit' : {
                        this.title_txt='Modification de l\'IP';
                        this.btn_txt='Modifier l\'IP';
                        this.main_placeholder='IP';
                    } break;
                    case 'formAPI_edit' : {
                        this.title_txt='Modification de la clé d\'API';
                        this.btn_txt='Modifier la clé d\'API';
                        this.main_placeholder='clé d\'API';
                    } break;
                    case 'formDico_edit' : {
                        // Pas de cas d'uilisation pour l'instant
                        this.title_txt='Modification du nom du dictionnaire';
                        this.btn_txt='Modifier le dictionnaire';
                        this.main_placeholder='Nom du dictionnaire';
                    } break;
                    case 'formCharte_edit' : {
                        this.title_txt='Modification du nom de la charte';
                        this.btn_txt='Modifier la charte';
                        this.main_placeholder='Nom de la charte';
                    } break;
                    case 'formTypo_edit' : {
                        this.title_txt='Modification du nom du dictionnaire typographique';
                        this.btn_txt='Modifier le dictionnaire typographique';
                        this.main_placeholder='Nom du dictionnaire typographique';
                    } break;
                    case 'formScript_edit' : {
                        this.title_txt='Modification de la clé de script';
                        this.btn_txt='Modifier la clé de script';
                        this.main_placeholder='Note';
                    } break;
                    //
                    // Suppression d'un objet
                    //
                    case 'formClient_remove' : {
                        this.validation = true;
                        this.title_txt='Suppression d\'un client';
                        this.btn_txt='Supprimer le client';
                        this.main_placeholder='Nom';
                    } break;
                    case 'formUser_remove' : {
                        this.validation = true;
                        this.title_txt='Suppression d\'un intervenant';
                        this.btn_txt='Supprimer l\'intervenant';
                        this.main_placeholder='Nom';
                    } break;
                    case 'formHost_remove' : {
                        this.validation = true;
                        this.title_txt='Suppression d\'un domaine';
                        this.btn_txt='Supprimer le domaine';
                        this.main_placeholder='Domaine';
                    } break;
                    case 'formSetting_remove' : {
                        this.validation = true;
                        this.title_txt='Suppression d\'une configuration';
                        this.btn_txt='Suppression la configuration';
                        this.main_placeholder='Configuration';
                    } break;
                    case 'formIP_remove' : {
                        this.validation = true;
                        this.title_txt='Suppression de l\'IP';
                        this.btn_txt='Supprimer l\'IP';
                        this.main_placeholder='IP';
                    } break;
                    case 'formAPI_remove' : {
                        this.validation = true;
                        this.title_txt='Suppression de la clé d\'API';
                        this.btn_txt='Supprimer la clé d\'API';
                        this.main_placeholder='clé d\'API';
                    } break;
                    case 'formDico_remove' : {
                        this.validation = true;
                        this.title_txt='Suppression du dictionnaire';
                        this.btn_txt='Supprimer le dictionnaire';
                        this.main_placeholder='Nom du dictionnaire';
                    } break;
                    case 'formCharte_remove' : {
                        this.validation = true;
                        this.title_txt='Suppression de la charte';
                        this.btn_txt='Supprimer la charte';
                        this.main_placeholder='Nom de la charte';
                    } break;
                    case 'formTypo_remove' : {
                        this.validation = true;
                        this.title_txt='Suppression du dictionnaire typographique';
                        this.btn_txt='Supprimer le dictionnaire typographique';
                        this.main_placeholder='Nom du dictionnaire typographique';
                    } break;
                    case 'formPrefs_remove' : {
                        this.validation = true;
                        this.title_txt='Suppression des préférences Myriade';
                        this.btn_txt='Supprimer les préférences Myriade';
                        this.main_placeholder='Préférences [Myriade]';
                    } break;
                    case 'formScript_remove' : {
                        this.title_txt='Suppression de la clé de script';
                        this.btn_txt='Supprimer la clé de script';
                        this.main_placeholder='clé de script';
                    } break;
                    ////////////
                    case 'formSub_removeAll' : {
                        this.validation = true;
                        this.title_txt='Suppression des soumissions';
                        this.btn_txt='Supprimer les soumissions';
                        this.main_placeholder='';
                        this.showPlaceholder = false;
                    } break;
                    case 'formPref_unavailable' : {
                        this.title_txt = 'Indisponible';
                        this.btn_txt='OK';
                        this.main_placeholder = '';
                        this.showPlaceholder = false;
                    } break;
                }

                if (newformInfos.data != undefined) {
                    // Clonage des données pour supprimé toutes modification aux données affiché (reactivité)
                    this.dataObj = {...newformInfos.data};
                }

                // 
                switch(this.mode) {
                    case 'formIP_remove' :
                    case 'formIP_edit' : {
                        this.dataObj.name = {...newformInfos.data}.ip;
                    } 
                    case 'formIP_new' : {
                        // Recuperation des configurations du client
                        //
                        axios(diagonalbackURL + "/clients/"+ this.$store.getters.currentClientId+"/settings",  defaultConfig)
                        .then(reponse => {
                            this.settingsForm = reponse.data;
                        })
                        .catch(error => this.errorHandler(error));
                    } break;
                    case 'formAPI_remove' :
                    case 'formAPI_edit' : {
                        this.dataObj.name = {...newformInfos.data}.value;
                    } 
                    case 'formAPI_new' : {
                        // Recuperation des configurations du client
                        //
                        axios(diagonalbackURL + "/clients/"+ this.$store.getters.currentClientId+"/settings",  defaultConfig)
                        .then(reponse => {
                            this.settingsForm = reponse.data;
                        })
                        .catch(error => this.errorHandler(error));
                    } break;
                }

            },
            // Affiche une erreur qui s'est produite aprés que l'utilisateur est validé son action via le bouton 
            showFormError(newformErrorInfos) {

                this.form_status="error_after";

                switch(newformErrorInfos.mode) {
                    case "formUser_error": {
                        this.errorTxt = "Cet intervenant existe déjà, veuillez contacter votre administrateur.";
                    } break;
                }
            },
            showOneBtnValidate() {
                // On affiche le bouton de validation unique si :
                // - pas en mode 'login'
                // - pas en mode 'XXX_remove'
                // - pas en mode 'forget_Mdp' ou en mode 'forget_Mdp' mais une fois que l'envoi du mail a été validé
                //
                return this.mode != 'login' && this.mode.indexOf('remove') == -1 && (this.mode!='forget_Mdp' || (this.mode=='forget_Mdp' && this.form_status == 'valid_userforget')  )
            },  
            showValidation() {
                if (this.mode == "forget_Mdp" && this.form_status == "valid_userforget") {
                    this.changeModeTo("login");
                }
                else if (this.mode == 'formPref_unavailable') {
                    this.closeForm();
                }
                else {
                    this.validation = true;
                }
            },
            showCloseBtn() {
                return  this.mode!='login' && this.mode != 'forget_Mdp'
            },
            showConfigFormLine() {
                switch(this.mode) {
                    //case 'formUser_new': case 'formUser_edit' : 
                    case 'formIP_new'  : case 'formIP_edit'  : case 'formIP_remove'  : 
                    case 'formAPI_new' : case 'formAPI_edit' : case 'formAPI_remove' : 
                        return true;
                    default : 
                        return false;
                }
            },
            showSwitchButton() {
                if (this.isRole(this.SUPERADMIN.value)) {
                    switch(this.mode) {
                        case "formHost_new" : case "formHost_edit" :
                        case "formAPI_edit" : case "formIP_edit" : 
                        case "formScript_edit" : { // passer en ADMIN
                            return true;
                        } break;
                        default : 
                            return false;
                    }
                }
                else {
                    return false;
                }
            },
            cancelValidation() {
                this.validation = false;
                if (this.mode.indexOf("remove") != -1) {
                    this.closeForm();
                }
                else if(this.mode == "forget_Mdp") {
                    this.changeModeTo("login");
                }
            },
            clickBtnForm() {

                if (this.validatedFields) {
                    if (this.mode == 'login') {
                        this.login();
                    }
                    else if (this.mode == 'forget_Mdp') {
                        this.sendMailForMdp();
                    }
                    else {
                        this.createObject();
                    }
                }

                this.validation = false;
            },
            login() {
                const self = this;
                this.$store.dispatch('login', {
                    mail: this.dataObj.name,
                    pwd: this.pswd,
                }).then(function () {
                    self.pswd = '';
                    self.display = false;
                    self.$router.push('/accueil');
                }, function (error) {
                    self.pswd = '';
                    self.errorHandler(error);
                })
            },
            sendMailForMdp() {
                const self = this;

                // Envoie d'un mail pour demander la reinitialisation du mot de passe'
                const params = JSON.stringify( {
                    'mail' : this.dataObj.name
                });
                
                axios.put(diagonalbackURL + "/users/activation", params, defaultConfig)
                .then(reponse => {
                    //console.log(reponse)
                    //this.$router.go()
                    //this.changeModeTo("login")
                    if (reponse.status == 200) {
                        self.form_status = 'valid_userforget'
                    }
                })
                .catch(function(error) {
                    self.errorHandler(error);

                    if (error.response.status == 404) {
                        self.form_status = 'error_userforget'
                        self.validation = true;
                    }
                }); 
            }, 
            createObject(){
                if (this.validatedFields) {
                    // Creation d'Objet
                    if (this.mode == 'formClient_new') {
                        this.emitter.emit('createClient', this.dataObj);
                    }
                    else if (this.mode == 'formUser_new') {
                        this.emitter.emit('createUser', this.dataObj);
                    }
                    else if (this.mode == 'formHost_new') {
                        this.emitter.emit('createHost', this.dataObj);
                    }
                    else if (this.mode == 'formSetting_new') {
                        this.emitter.emit('createSetting', this.dataObj);
                    }
                    else if (this.mode == 'formIP_new') {
                        this.emitter.emit('createIP', this.dataObj);
                    }
                    else if (this.mode == 'formAPI_new') {
                        this.emitter.emit('createAPI', this.dataObj);
                    }
                    else if (this.mode == 'formDico_new') {
                        this.emitter.emit('createDico', this.dataObj);
                    }
                    else if (this.mode == 'formCharte_new') {
                        this.emitter.emit('createCharte', this.dataObj);
                    }
                    else if (this.mode == 'formTypo_new') {
                        this.emitter.emit('createTypo', this.dataObj);
                    }
                    else if (this.mode == 'formScript_new') {
                        this.emitter.emit('createScript', this.dataObj);
                    }
                    //
                    // Modification d'Objet
                    //
                    if (this.mode == 'formClient_edit') {
                        // Do not exist for now
                        this.emitter.emit('editClient', this.dataObj);
                    }
                    else if (this.mode == 'formUser_edit') {
                        this.emitter.emit('editUser', this.dataObj);
                    }
                    else if (this.mode == 'formHost_edit') {
                        this.emitter.emit('editHost', this.dataObj);
                    }
                    else if (this.mode == 'formSetting_edit') {
                        this.emitter.emit('editSetting', this.dataObj);
                    }
                    else if (this.mode == 'formIP_edit') {
                        this.emitter.emit('editIP', this.dataObj);
                    }
                    else if (this.mode == 'formAPI_edit') {
                        this.emitter.emit('editAPI', this.dataObj);
                    }
                    else if (this.mode == 'formDico_edit') {
                        this.emitter.emit('editDico', this.dataObj);
                    }
                    else if (this.mode == 'formCharte_edit') {
                        this.emitter.emit('editCharte', this.dataObj);
                    }
                    else if (this.mode == 'formTypo_edit') {
                        this.emitter.emit('editTypo', this.dataObj);
                    }
                    else if (this.mode == 'formScript_edit') {
                        this.emitter.emit('editScript', this.dataObj);
                    }
                    //
                    // Suppression d'Objet
                    //
                    if (this.mode == 'formClient_remove') {
                        this.emitter.emit('removeClient', this.dataObj);
                    }
                    else if (this.mode == 'formUser_remove') {
                        this.emitter.emit('removeUser', this.dataObj);
                    }
                    else if (this.mode == 'formHost_remove') {
                        this.emitter.emit('removeHost', this.dataObj);
                    }
                    else if (this.mode == 'formSetting_remove') {
                        this.emitter.emit('removeSetting', this.dataObj);
                    }
                    else if (this.mode == 'formIP_remove') {
                        this.emitter.emit('removeIP', this.dataObj);
                    }
                    else if (this.mode == 'formAPI_remove') {
                        this.emitter.emit('removeAPI', this.dataObj);
                    }
                    else if (this.mode == 'formDico_remove') {
                        this.emitter.emit('removeDico', this.dataObj);
                    }
                    else if (this.mode == 'formCharte_remove') {
                        this.emitter.emit('removeCharte', this.dataObj);
                    }
                    else if (this.mode == 'formTypo_remove') {
                        this.emitter.emit('removeTypo', this.dataObj);
                    }
                    else if (this.mode == 'formPrefs_remove') {
                        this.emitter.emit('removePrefs', this.dataObj);
                    }
                    else if (this.mode == 'formScript_remove') {
                        this.emitter.emit('removeScript', this.dataObj);
                    }
                    ////
                    else if (this.mode == 'formSub_removeAll') {
                        this.emitter.emit('removeSubmission_All', this.dataObj);
                        // Pas de refresh dans le removeAll, du coup on ferme manuellement
                        this.closeForm();
                    }
                }
            },
            closeForm(){
                this.display = false;
                this.mode='none';
                this.pswd='';
                this.validation = false;
                this.errorTxt="";
                this.showPlaceholder = true;

                this.dataObj = {
                    id:'',
                    name: '',
                    firstName: '',
                    mail: '',
                    note:'',
                    role:RoleEnum.LINGUIST.value,
                    active:false,
                    clientId:'',
                    settingId:''
                }
            },
            filterInput(event) {
                let regex;

                switch(this.mode) {
                    case "formClient_edit" :
                    case "formClient_new"  : {
                        // autorise les chiffres et le caractére -
                        regex = /[^0-9-]/g;
                    } break;
                    default : {
                        regex  = /./g;
                    } break;
                }

                event.target.value = event.target.value.replace(regex, "");
                this.dataObj.code = event.target.value;

            }
        }
    }
</script>


<!-- 
    Attention, le CSS ici n'est pas scoped, car j'utilise les form dans une autre page
    -> User.vue
-->
<style >

#formbackground {
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    z-index: 10;

    background-color: #88888870;

    /* Attention IE */
    display: flex;
    align-items: center;
    justify-content: center;

}

#closeFormBtn {
    background: none;
    border: none;
    position: absolute;
    color: #cc0b00;
    font-weight: bold;
    font-family: "Titillium Web";
    font-size: 13pt;
    right: 6px;
    top: 3px;
}

#formPL {
    position: relative;
    background-color: #ffffff;
    width: 540px;
    max-width: 100%;
    border-radius: 16px;
    padding: 32px;
}

.form_title {
    text-align: center;
    font-weight: bold;
}


.form_row {
    display: flex;
    margin: 16px 0px;
    gap: 16px;
    flex-wrap: wrap;
}


.form_input {
    padding: 8px;
    border: none;
    border-radius: 8px;
    background: #f2f2f2;
    font-weight: 500;
    font-size: 16px;
    flex: 1;
    min-width: 100px;
    color: black;
}

.form_input:disabled {
    color : grey;
}


.form_button {
    background: #2196F3;
    color: white;
    border-radius: 8px;
    font-weight: 800;
    font-size: 15px;
    border: none;
    width: 100%;
    padding: 16px;
    transition: .4s background-color;
}

.form_button:hover:not(.form_button_disabled) {
    background: #63ace7;
}

.form_button:active:not(.form_button_disabled) {
  transform: translateY(2px);
}

.form_button_disabled {
    background: #cecece;
    color: #ececec;
    cursor:not-allowed;
}

.form_button.half_btn {
    width:49%;
}

.form_error{
    color:#cc0b00;
    justify-content: center;
}

.form_checkbox_txt {
    padding-left : 8px;
    font-size: 16px;
    font-weight: bold;
    flex:30;
    line-height: 45px;
}

.form_checkbox {
    min-width:0;
}

#forget_mdp {
    margin-left: auto;
    color : #2196F3;
}



.form_row.validation {
    gap: 10px;
    max-height: 0px;
    overflow-y: hidden;

    transition: max-height 0.5s linear;
}

.form_row.validation.showbtn {
    max-height: 100px;

}

</style>
